import { render, staticRenderFns } from "./modelWatchInfoRightTwo.vue?vue&type=template&id=c2a28c8e&scoped=true&"
import script from "./modelWatchInfoRightTwo.vue?vue&type=script&lang=js&"
export * from "./modelWatchInfoRightTwo.vue?vue&type=script&lang=js&"
import style0 from "./modelWatchInfoRightTwo.vue?vue&type=style&index=0&id=c2a28c8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a28c8e",
  null
  
)

export default component.exports